import { environment } from 'src/environments/environment';

export const URL_SERVICIOS = environment.urlServicios;
export const URL_SERVICIOS_SALES_ROOM = environment.SalesRoomUrlServicios;
export const URL_SERVICIOS_INVENTORY = environment.urlInventory;
export const URL_SERVICIOS_NOVELTIES = environment.urlNovelties;
export const ambiente = environment.env;


